<template>
    <v-container pa-0
                 v-if="transactions.length > 0">
        <heading-section v-if="!hideTitle"
                         class="d-flex">
            {{ $vuetify.lang.t('$vuetify.widgets.transactions.title') }}
        </heading-section>
        <v-expansion-panels tile
                            flat
                            accordion>
            <v-expansion-panel v-for="(transaction ,i) in transactions"
                               :class="i % 2 !== 0 ? 'grey darken-3' : ''"
                               :key="i">
                <v-expansion-panel-header expand-icon="mdi-menu-down"
                                          class="py-1 pr-2">
                    <v-row class="pr-2">
                        <v-col cols="auto">
                            <p class="ma-0">{{ transaction.created_at | date }}</p>
                        </v-col>
                        <v-col class="px-3"
                               v-if="transaction.meta && transaction.meta.contract_details && transaction.type_id !== 2">
                            <p class="mb-0">
                                <span v-if="transaction.type_id === 5">{{
                                        $vuetify.lang.t('$vuetify.transaction_labels.declined_contract')
                                                                       }}: </span>
                                <template v-if="transaction.type_id === 6">
                                    {{ transaction.meta.description }}
                                </template>
                                <template v-else>
                                    {{ transaction.meta.contract_details.model_name }}
                                </template>
                            </p>
                            <p v-if="transaction.meta && !transaction.meta.is_manual_transaction"
                               class="mb-0 caption grey--text">{{
                                    $vuetify.lang.t('$vuetify.form_items.ab_number_prefix')
                                                               }}{{ transaction.meta.contract_details.ab_number }}</p>
                        </v-col>

                        <v-col class="px-3"
                               v-else>
                            <p class="mb-0">{{ transaction.type }}
                                <span v-if="transaction.type_id === 2">| {{ transaction.meta.description }}</span></p>
                            <p class="mb-0 caption grey--text"
                               v-if="transaction.type_id === 2">{{
                                    $vuetify.lang.t('$vuetify.form_items.ab_number_prefix')
                                                                }}{{ transaction.meta.old_ab_number }}</p>
                        </v-col>

                        <v-col cols="auto"
                               :class="{ 'success--text': transaction.value > 0, 'error--text': transaction.value < 0, 'secondary--text': transaction.value == 0 }"
                               class="">
                            <div>{{ transaction.value | number | balance }}</div>
                            <div v-if="transaction.type_id == 2 || (transaction.type_id == 3 && transaction.canceled)"
                                 class="mt-1 text-right">
                                <v-icon color="error"
                                        size="20">mdi-cancel
                                </v-icon>
                            </div>
                        </v-col>
                    </v-row>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-divider class="mb-4"></v-divider>

                    <template v-if="transaction.type_id === 10">
                        <p class="mb-0">{{ transaction.description }}</p>
                    </template>

                    <template v-if="transaction.meta && transaction.meta.contract_details && !transaction.meta.is_manual_transaction">
                        <p class="mb-0"
                           v-if="transaction.reason && transaction.type_id === 5">
                            {{ $vuetify.lang.t('$vuetify.transaction_labels.contract_cancel_reason') }}:
                            {{ transaction.reason }}</p>
                        <p class="mb-0">{{ $vuetify.lang.t('$vuetify.form_items.contract_date') }}:
                                        {{ transaction.meta.contract_details.order_date_customer | date }}</p>
                        <p class="mb-0">{{ $vuetify.lang.t('$vuetify.form_items.potential_delivery_date') }}:
                                        {{ transaction.meta.contract_details.potential_delivery_date | date }}</p>
                        <p class="mb-0">
                            {{ $vuetify.lang.t('$vuetify.transaction_labels.vin') }}:
                            <template v-if="transaction.meta.contract_details.vin">
                                {{ transaction.meta.contract_details.vin }}
                            </template>
                            <template v-else>
                                {{ $vuetify.lang.t('$vuetify.widgets.transactions.empty_vin') }}
                            </template>
                        </p>
                        <p class="mb-0">{{ $vuetify.lang.t('$vuetify.transaction_labels.model_category') }}:
                                        {{ transaction.meta.contract_details.model_category }}</p>
                        <p class="mb-0">{{ $vuetify.lang.t('$vuetify.transaction_labels.brand') }}:
                            <span class="text-uppercase">{{ transaction.meta.contract_details.brand }}</span></p>
                        <p class="mb-0"
                           v-if="transaction.meta.contract_details.commission">
                            {{ $vuetify.lang.t('$vuetify.form_items.commission') }}:
                            {{ transaction.meta.contract_details.commission }}</p>
                    </template>

                    <!-- canceled transactions -->
                    <template v-if="transaction.type_id === 2 && transaction.meta && !transaction.meta.is_manual_transaction">
                        <p>{{ transaction.meta.info }}</p>
                        <p class="mb-0"
                           v-if="transaction.reason">
                            {{ $vuetify.lang.t('$vuetify.transaction_labels.contract_cancel_reason') }}:
                            {{ transaction.reason }}</p>
                        <p class="mb-0">{{ $vuetify.lang.t('$vuetify.transaction_labels.contract_submission_date') }}:
                                        {{ transaction.meta.old_created_at | date }}</p>
                        <p class="mb-0">{{ $vuetify.lang.t('$vuetify.transaction_labels.model_name') }}:
                                        {{ transaction.meta.old_model_name }}</p>
                        <p class="mb-0">
                            {{ $vuetify.lang.t('$vuetify.transaction_labels.vin') }}:
                            <template v-if="transaction.meta.old_vin">
                                {{ transaction.meta.old_vin }}
                            </template>
                            <template v-else>
                                {{ $vuetify.lang.t('$vuetify.widgets.transactions.empty_vin') }}
                            </template>
                        </p>
                    </template>
                    <!-- /canceled transactions -->

                    <!-- order transactions -->
                    <template v-if="(transaction.type_id == 3 || transaction.type_id == 7) && transaction.meta">
                        <p class="mb-0"
                           v-if="transaction.reason">
                            {{ $vuetify.lang.t('$vuetify.transaction_labels.contract_cancel_reason') }}:
                            {{ transaction.reason }}</p>
                        <p class="mb-0">{{ $vuetify.lang.t('$vuetify.transaction_labels.order_no') }}:
                                        {{ transaction.meta.purchase_id }}</p>
                        <p class="mb-0">{{ $vuetify.lang.t('$vuetify.transaction_labels.order_product') }}:
                                        {{ transaction.meta.product_name }}</p>
                    </template>
                    <!-- /order transactions -->

                    <!-- manual transactions -->
                    <template v-if="transaction.type_id === 4 && transaction.meta || transaction.meta && transaction.meta.is_manual_transaction">
                        <p class="mb-0">{{ transaction.description }}</p>
                    </template>
                    <!-- /manual transactions -->
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </v-container>
</template>

<script>
// components
import HeadingSection from '../../components/HeadingSection';

export default {
    name: 'transactions',
    components: {
        HeadingSection,
    },
    props: {
        transactions: {
            required: true,
            type: Array,
        },
        hideTitle: {
            required: false,
            type: Boolean,
            default: false,
        },
    },
};
</script>
